import { Badge, Box, Heading, HStack, Text, VStack } from '@chakra-ui/react'
import type { LucideIcon } from 'lucide-react'
import { Factory, Server, Truck, Zap } from 'lucide-react'
import type { IcpData } from '@/data/business-value'

const iconMap: Record<string, LucideIcon> = {
  Factory,
  Zap,
  Server,
  Truck,
}

interface HeroBannerProps {
  icp: IcpData
  tags?: string[]
}

export default function HeroBanner({ icp, tags }: HeroBannerProps) {
  const Icon = iconMap[icp.icon] || Factory

  return (
    <Box
      w="100%"
      py={12}
      px={8}
      borderRadius="2xl"
      bgGradient="to-r"
      gradientFrom={icp.gradient.from}
      gradientTo={icp.gradient.to}
      color="white"
    >
      <VStack gap={4} align="start" maxW="3xl">
        <Box p={3} borderRadius="xl" bg="whiteAlpha.200">
          <Icon size={32} />
        </Box>
        <Heading size="2xl">{icp.title}</Heading>
        <Text fontSize="lg" opacity={0.9}>
          {icp.fullDescription}
        </Text>
        {tags && tags.length > 0 && (
          <HStack gap={2} flexWrap="wrap" pt={2}>
            {tags.map((tag) => (
              <Badge
                key={tag}
                size="sm"
                variant="subtle"
                bg="whiteAlpha.200"
                color="white"
                borderRadius="full"
                px={3}
                py={1}
              >
                {tag}
              </Badge>
            ))}
          </HStack>
        )}
      </VStack>
    </Box>
  )
}
